export default __webpack_public_path__ + "static/media/event-image-placeholder.e4e17342.jpg";